import { getRunningEnv } from 'helper/utils';
import channelAPPConfig from './index';

const configuration = () => {
	const path = getRunningEnv();
	console.log(`Running on ${path} environment.`);
	return channelAPPConfig;
};

export default configuration();
